import "tempusdominus-bootstrap-3"
import "tempusdominus-bootstrap-3/build/css/tempusdominus-bootstrap-3.css"

$(function() {
  $(".datetimepicker-container").datetimepicker({ format: "YYYY-MM-DD" })
})
